import cn from 'classnames';
import styles from './UpsaleInfoSection.module.scss';
import { Image } from '../Image/Image';
export const UpsaleInfoSection = ({content})=>{
  if(!content){
    return;
  }
  const { title,highlightedText,image,contentBackground,contentIcon,contentTitle, content:contentText, contentAlign, facts } = content;
  let contentString = null;
  if(contentText){
    contentString = contentText.join('');
  }
  return (
    <div className={styles.wrapper}>
        {title && <div className={cn(
          styles.title,
          highlightedText==='green' && styles.green,
          highlightedText==='purple' && styles.purple,
          
        )} dangerouslySetInnerHTML={{ __html:title }}/>}
        {image && <Image src={image} className={styles.image}/>}
        <div className={cn(
          styles.block,
          contentBackground === 'purple' && styles.blockPurple,
          contentBackground === 'grey' && styles.blockGrey,
        )}>
          {contentIcon && <Image src={contentIcon} className={styles.contentIcon} />}
          {contentTitle &&
            <div className={cn(styles.contentTitle )} dangerouslySetInnerHTML={{ __html:contentTitle }}/>
          }
          {contentText &&
          <div className={cn(
            styles.content,
            contentBackground === 'purple' && styles.textWhite,
            contentAlign ==='left' && styles.textLeft
          )} dangerouslySetInnerHTML={{ __html: contentString }}/>
          }
          {facts &&
            <div className={styles.facts}>
              {
                facts.map((fact,index)=>{
                  const {icon,text,source}= fact;
                  return(
                  <div className={styles.box} key={index}>
                    <div className={styles.icon}>
                      {icon && <Image src={icon}/>}
                    </div>
                    <div className={styles.boxContent}>
                      <div className={styles.boxText}>{text}</div>
                      <a href={source.link} target='_blank' className={styles.boxLink}>{source.text}</a>
                    </div>
                  </div>
                  )
                  
                })
              }
            </div>
          }
        </div>
    </div>
  )
}